module.exports = __webpack_public_path__ + "static/media/Total_Uploads_Icon.203d1fd0.svg";